import classNames from "classnames";

import styles from "./StatCard.module.scss";

export enum StatCardValueVariant {
  Orange = "orange",
  Green = "green",
  Black = "black",
}

type StatCardProps = {
  value: number | string;
  label: string;
  secondaryValue?: number | string;
  variant?: StatCardValueVariant;
  textColor?: string;
};

export const StatCard: React.FC<StatCardProps> = ({
  value,
  secondaryValue,
  label,
  variant = StatCardValueVariant.Black,
  textColor,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.valueContainer}>
        <h6 className={classNames(styles.value, styles[variant])} style={textColor ? { color: textColor } : undefined}>
          {value}
        </h6>
        {secondaryValue !== undefined && <p className={styles.secondaryValue}>{secondaryValue}</p>}
      </div>
      <p className={styles.label}>{label}</p>
    </div>
  );
};
